"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.print = void 0;
exports.print = {
    path: "M15.8327 6.66667H14.9993V2.5H4.99935V6.66667H4.16602C2.78268 6.66667 1.66602 7.78333 1.66602 9.16667V14.1667H4.99935V17.5H14.9993V14.1667H18.3327V9.16667C18.3327 7.78333 17.216 6.66667 15.8327 6.66667ZM6.66602 4.16667H13.3327V6.66667H6.66602V4.16667ZM6.66602 15.8333H13.3327V12.5H6.66602V15.8333ZM14.9993 12.5V10.8333H4.99935V12.5H3.33268V9.16667C3.33268 8.70833 3.70768 8.33333 4.16602 8.33333H15.8327C16.291 8.33333 16.666 8.70833 16.666 9.16667V12.5H14.9993ZM14.166 9.58333C14.166 9.1231 14.5391 8.75 14.9993 8.75C15.4596 8.75 15.8327 9.1231 15.8327 9.58333C15.8327 10.0436 15.4596 10.4167 14.9993 10.4167C14.5391 10.4167 14.166 10.0436 14.166 9.58333Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
